<h2 mat-dialog-title>Edit User Profile</h2>
<mat-dialog-content>
  <form [formGroup]="editUserProfileForm">
    <div class="row" style="flex-direction: row; box-sizing: border-box; display: flex; gap: 20px;">
      <div style="flex: 1 1 0%; box-sizing: border-box;">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>User Name</mat-label>
          <input matInput placeholder="User Name" formControlName="userName">
          <mat-error *ngIf="editUserProfileForm.controls['userName'].invalid && (editUserProfileForm.controls['userName'].touched || editUserProfileForm.controls['userName'].dirty)">
            <p *ngIf="editUserProfileForm.controls['userName'].errors.empty">User Name is <strong>required</strong></p>
            <p *ngIf="editUserProfileForm.controls['userName'].errors.maxlength">User Name can not exceed <strong>256</strong> characters.</p>
          </mat-error>
        </mat-form-field>
      </div>
      <div style="flex: 1 1 0%; box-sizing: border-box;">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Email</mat-label>
          <input matInput placeholder="Email" formControlName="email">
          <mat-error *ngIf="editUserProfileForm.controls['email'].invalid && (editUserProfileForm.controls['email'].touched || editUserProfileForm.controls['email'].dirty)">
            <p *ngIf="editUserProfileForm.controls['email'].errors.empty">Email is <strong>required</strong></p>
            <p *ngIf="editUserProfileForm.controls['email'].errors.maxlength">Email can not exceed <strong>256</strong> characters.</p>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row" style="flex-direction: row; box-sizing: border-box; display: flex; gap: 20px;">
      <div style="flex: 1 1 0%; box-sizing: border-box;">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Organization</mat-label>
          <input matInput placeholder="Organization Name" formControlName="organization">
          <mat-error *ngIf="editUserProfileForm.controls['organization'].invalid && (editUserProfileForm.controls['organization'].touched || editUserProfileForm.controls['organization'].dirty)">
            <p *ngIf="editUserProfileForm.controls['organization'].errors.maxlength">Organization Name can not exceed <strong>256</strong> characters.</p>
          </mat-error>
        </mat-form-field>
      </div>
      <div style="flex: 1 1 0%; box-sizing: border-box;">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Salutation</mat-label>
          <mat-select matInput formControlName="salutation">
            <mat-option *ngFor="let s of salutations" [value]="s.displayName">
              {{s.displayName}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; gap: 20px;">
      <div style="flex: 1 1 0%; box-sizing: border-box;">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>First Name</mat-label>
          <input matInput placeholder="First Name" formControlName="firstName">
          <mat-error *ngIf="editUserProfileForm.controls['firstName'].invalid && (editUserProfileForm.controls['firstName'].touched || editUserProfileForm.controls['firstName'].dirty)">
            <p *ngIf="editUserProfileForm.controls['firstName'].errors.empty">First Name is <strong>required</strong></p>
            <p *ngIf="editUserProfileForm.controls['firstName'].errors.maxlength">First Name can not exceed <strong>256</strong> characters.</p>
          </mat-error>
        </mat-form-field>
      </div>
      <div style="flex: 1 1 0%; box-sizing: border-box;">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Last Name</mat-label>
          <input matInput placeholder="Last Name" formControlName="lastName">
          <mat-error *ngIf="editUserProfileForm.controls['lastName'].invalid && (editUserProfileForm.controls['lastName'].touched || editUserProfileForm.controls['lastName'].dirty)">
            <p *ngIf="editUserProfileForm.controls['lastName'].errors.empty">Last Name is <strong>required</strong></p>
            <p *ngIf="editUserProfileForm.controls['lastName'].errors.maxlength">Last Name can not exceed <strong>256</strong> characters.</p>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" id="submitEditUserProfileForm" [disabled]="editUserProfileForm.pristine ||!editUserProfileForm.valid" (click)="submit()">Update</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
